//bg
import FastAverageColor from "fast-average-color";

import { getId } from './util.js';
import { updateBg, updateBgZoom } from "./preview";

let settingsBg = getId("settingsBg");
settingsBg.addEventListener("change", readBg, true);

export default function readBg() {
    var file = settingsBg.files[0];
    var reader = new FileReader();

    reader.onload = function () {
        cardBg.src = reader.result;
        updateBg(0, 0);
        updateBgZoom(1);
        avgColor(getId('cardBg'))
            .then(color => {
                card.style.background = color.rgb;
            })
            .catch(console.error);
    }
    reader.onerror = function () {
        console.error("Error loading file")
    }

    if (file) {
        reader.readAsDataURL(file);
    }
}

//avg colour
async function avgColor (imgSrc) {
    const fac = new FastAverageColor();
    return await fac.getColorAsync(imgSrc, { algorithm: 'dominant' });
}